export const JPG = 'jpg'
export const JPEG = 'jpeg'
export const PNG = 'png'
export const PDF = 'pdf'
export const WORD = 'doc'
export const WORDX = 'docx'
export const EXCEL = 'xls'
export const EXCELX = 'xlsx'
export const CSV = 'csv'

export const IMAGE_FORMATS = [JPG, JPEG, PNG]
export const WORD_FORMATS = [WORD, WORDX]
export const EXCEL_FORMATS = [EXCEL, EXCELX]
export const DOCUMENT_FORMATS = [...WORD_FORMATS, ...EXCEL_FORMATS, PDF, CSV]

export const ACCEPT = `.${JPG}, .${JPEG}, .${PNG}, .${PDF}, .${WORD}, .${WORDX}, .${EXCEL}, .${EXCELX}, .${CSV}`
export const ACCEPT_SWMS = `.${JPG}, .${JPEG}, .${PNG}, .${PDF}, .${WORD}, .${WORDX}`
export const ACCEPT_IMAGES = IMAGE_FORMATS.map((f) => `.${f}`).join(', ')
export const ACCEPT_SANS_WORD = `.${JPG}, .${JPEG}, .${PNG}, .${PDF}`

export const FORMATTED_ACCEPT = ACCEPT.replace(/, /g, ' ')
export const FORMATTED_ACCEPT_IMAGES = ACCEPT_IMAGES.replace(/, /g, ' ')

export const formatAccept = (accept: string) => {
  if (!accept?.length) return 'all files'

  return accept.replace(/, /g, ' ')
}

export const MAX_SIZE_MB = 20
export const MAX_SIZE_B = MAX_SIZE_MB * 1024 * 1024
